/**
 * NWT_Core_Services
 * <h1>NWT_Core_Services</h1>
 *
 * OpenAPI spec version: 
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


/**
 * 
 */
export type JsonCustomerClass = 'RESIDENTIAL' | 'COMMERCIAL';

export const JsonCustomerClass = {
    RESIDENTIAL: 'RESIDENTIAL' as JsonCustomerClass,
    COMMERCIAL: 'COMMERCIAL' as JsonCustomerClass
}
